function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import settings from './_mediaZoom.settings';
import * as utils from './_mediaZoom.utils';
import SwiperSlider from 'integration-web-core--socle/js/assets/modules/_swiperSlider.class';
var MediaZoom = /*#__PURE__*/function () {
  function MediaZoom(mediaZoom) {
    var _this = this;
    _classCallCheck(this, MediaZoom);
    this.mediaZoom = mediaZoom;
    this.openButtons = document.querySelectorAll('.js-open-media-zoom');
    this.closeButton = mediaZoom.querySelector('.js-close-media-zoom');
    this.thumbnails = mediaZoom.querySelector('.mz__thumbnails');
    this.thumbnailsItems = this.thumbnails.querySelectorAll('.mz__thumbnails__list-item');
    this.thumbnailsArrowButtons = this.thumbnails.querySelectorAll('.mz__thumbnails__button');
    this.medias = mediaZoom.querySelector('.mz__medias__list');
    this.mediasSwiper = mediaZoom.querySelector('.mz__medias__swiper');
    this.mediasItems = this.medias.querySelectorAll('.mz__medias__list-item');
    this.mediasArrowButtons = this.mediasSwiper.querySelectorAll('.ka-nav-button');
    this.mediasZoomButtons = mediaZoom.querySelectorAll('.mz__medias__buttons button');
    this.currentIndex = 0;
    this.currentThumbnail = this.thumbnailsItems[0];
    this.currentMedia = this.mediasItems[0];
    this.currentZoom = settings.zoom.min;
    this.currentPinch = 1;
    this.currentPosX = 0;
    this.currentPosY = 0;
    this.isMoving = false;
    lm.DOMReady(function () {
      return _this.init();
    });
  }

  /**
   * Init module and set event listeners
   */
  return _createClass(MediaZoom, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // Open/Close
      this.openButtons.forEach(function (button) {
        return button.addEventListener('click', function (e) {
          return _this2.open(e);
        });
      });
      this.closeButton.addEventListener('click', function (e) {
        return _this2.close(e);
      });

      // Thumbnails
      this.thumbnailsArrowButtons.forEach(function (arrow) {
        return arrow.addEventListener('click', function (e) {
          return _this2.onThumbnailsArrowClick(e, arrow);
        });
      });
      this.thumbnailsItems.forEach(function (item) {
        return item.addEventListener('click', function (e) {
          return _this2.onThumbnailsItemsClick(e);
        });
      });
      this.thumbnails.addEventListener('scroll', function () {
        return utils.debounce(_this2.toggleThumbnailsArrowButtons, 3000);
      });

      // Medias
      this.mediasArrowButtons.forEach(function (arrow) {
        return arrow.addEventListener('click', function (e) {
          return _this2.onMediasArrowClick(e, arrow);
        });
      });
      this.mediasZoomButtons.forEach(function (button) {
        return button.addEventListener('click', function () {
          return _this2.onZoomButtonsClick(button.dataset.direction);
        });
      });
      this.medias.addEventListener('scroll', function () {
        return utils.debounce(_this2.toggleMediasArrowButtons, 3000);
      });

      // Launch swiper
      this.mediasSwiper && new SwiperSlider(this.mediasSwiper);

      // Init keyboard actions
      this.initKeyboardActions();
    }

    /**
     * User click on a thumbnail item
     * @param {event} event
     */
  }, {
    key: "onThumbnailsItemsClick",
    value: function onThumbnailsItemsClick(event) {
      this.enableArrows(false);
      this.goTo(event.target.closest('.mz__thumbnails__list-item').dataset.index || 0, 'smooth');
    }
  }, {
    key: "initKeyboardActions",
    value:
    /**
     * Manage keyboard interactions for A11Y
     */
    function initKeyboardActions() {
      var _this3 = this;
      window.addEventListener('keydown', function (event) {
        if (_this3.isOpen && !_this3.isMoving) {
          var _settings$zoom = settings.zoom,
            min = _settings$zoom.min,
            max = _settings$zoom.max,
            step = _settings$zoom.step;
          if (event.key === 'Escape') {
            _this3.close();
          }
          switch (event.key) {
            case 'ArrowLeft':
              /* Go to previous slide or Drag to left if image is zoomed */
              if (!_this3.isZoomed) _this3.goTo(_this3.currentIndex - 1, 'smooth');else _this3.drag(_this3.currentMedia, _this3.currentPosX += 100, _this3.currentPosY);
              break;
            case 'ArrowRight':
              /* Go to next slide or Drag to right if image is zoomed */
              if (!_this3.isZoomed) _this3.goTo(_this3.currentIndex + 1, 'smooth');else _this3.drag(_this3.currentMedia, _this3.currentPosX -= 100, _this3.currentPosY);
              break;
            case 'ArrowUp':
              /* Drag to top if image is zoomed */
              _this3.drag(_this3.currentMedia, _this3.currentPosX, _this3.currentPosY += 100);
              break;
            case 'ArrowDown':
              /* Drag to bottom if image is zoomed */
              _this3.drag(_this3.currentMedia, _this3.currentPosX, _this3.currentPosY -= 100);
              break;
            case '+':
              /* Zoom In   */
              _this3.zoom(_this3.currentMedia, utils.getMinMax(_this3.currentZoom + step, min, max), true);
              break;
            case '-':
              /* Zoom Out */
              _this3.zoom(_this3.currentMedia, utils.getMinMax(_this3.currentZoom - step, min, max), true);
              break;
          }
        }
      });
    }

    /**
     * Init user interaction events
     */
  }, {
    key: "initHammer",
    value: function initHammer() {
      var _this4 = this;
      import(/*webpackChunkName: "hammerjs" */'hammerjs').then(function (module) {
        _this4.Hammer = new module["default"](_this4.medias, {
          inputClass: Hammer.TouchMouseInput
        });
        _this4.Hammer.on('pan', function (e) {
          return _this4.onPan(e);
        }).get('pan').set(settings.hammer.pan);
        _this4.Hammer.on('pinch', function (e) {
          return _this4.onPinch(e);
        }).get('pinch').set(settings.hammer.pinch);
        _this4.Hammer.on('swipe', function (e) {
          return _this4.onSwipe(e);
        }).get('swipe').set(settings.hammer.swipe);
        _this4.Hammer.on('tap', function (e) {
          return _this4.onTap(e);
        }).get('tap').set(settings.hammer.tap);
        !utils.isTouchDevice() && _this4.medias.addEventListener('mousewheel', function (e) {
          return _this4.onMouseWheel(e);
        }, {
          passive: false
        });
      })["catch"](console.error);
    }

    /**
     * Open media zoom in full page
     * @param {event} event
     */
  }, {
    key: "open",
    value: function open(event) {
      var _this5 = this;
      var index = event.target.closest('.js-open-media-zoom').dataset.index || 0;
      this.goTo(index, 'instant');
      if (!this.Hammer) this.initHammer();
      window.addEventListener('resize', function () {
        return _this5.close();
      }, {
        once: true
      });
      document.documentElement.classList.add('is-scroll-locked');
      this.mediaZoom.classList.add('active');
      this.isOpen = true;
      this.closeButton.focus();
      this.toggleThumbnailsArrowButtons();
      this.toggleMediasArrowButtons();
      lm.lazyload.observe();
    }

    /**
     * Close Media zoom
     */
  }, {
    key: "close",
    value: function close() {
      document.documentElement.classList.remove('is-scroll-locked');
      this.mediaZoom.classList.remove('active');
      this.goTo(0, 'instant');
      this.isOpen = false;
      this.pauseAllVideos();
      this.resetZoom();
      this.resetDrag();
    }

    /**
     * User drag image
     * @param {event} event
     */
  }, {
    key: "onPan",
    value: function onPan(event) {
      if (this.isZoomed && !this.isMoving) {
        var image = this.currentMedia.querySelector('img');
        if (!this.isDragging) {
          this.isDragging = true;
          this.currentMedia.classList.add('grabbing');
        }
        this.drag(this.currentMedia, event.deltaX + this.currentPosX, event.deltaY + this.currentPosY);
        if (event.isFinal) {
          this.currentPosX = image.offsetLeft;
          this.currentPosY = image.offsetTop;
          this.isDragging = false;
          this.currentMedia.classList.remove('grabbing');
        }
      }
    }

    /**
     * User tap on screen or click
     * @param {event} event
     */
  }, {
    key: "onTap",
    value: function onTap(event) {
      if (!this.isMoving) {
        var _settings$zoom2 = settings.zoom,
          max = _settings$zoom2.max,
          min = _settings$zoom2.min;
        var newZoomValue;
        if (this.currentZoom < max / 2) newZoomValue = max / 2;
        if (this.currentZoom >= max / 2) newZoomValue = max;
        if (this.currentZoom === max) newZoomValue = min;
        this.zoom(this.currentMedia, newZoomValue, true);
      }
    }

    /**
     * User pinch image
     * @param {event} event
     */
  }, {
    key: "onPinch",
    value: function onPinch(event) {
      var _this6 = this;
      if (!this.isMoving) {
        var _settings$zoom3 = settings.zoom,
          min = _settings$zoom3.min,
          max = _settings$zoom3.max;
        var pinchValue = this.currentPinch * event.scale;
        var newZoomValue = Math.round(utils.getMinMax(pinchValue * 100, min, max));
        this.zoom(this.currentMedia, newZoomValue, false);
        this.Hammer.off('pinchend').on('pinchend', function () {
          _this6.currentPinch = pinchValue;
        });
      }
    }

    /**
     * User swipe image
     * @param {event} event
     */
  }, {
    key: "onSwipe",
    value: function onSwipe(event) {
      if (!this.isMoving) {
        if (event.deltaX > 0) this.goTo(this.currentIndex - 1, 'smooth');
        if (event.deltaX < 0) this.goTo(this.currentIndex + 1, 'smooth');
      }
    }

    /**
     * User uses his mouse wheel
     * @param {event} event
     */
  }, {
    key: "onMouseWheel",
    value: function onMouseWheel(event) {
      event.preventDefault();
      if (!this.isMoving) {
        var _settings$zoom4 = settings.zoom,
          min = _settings$zoom4.min,
          max = _settings$zoom4.max,
          wheel_speed = _settings$zoom4.wheel_speed;
        var newZoomValue = utils.getMinMax(this.currentZoom - wheel_speed * event.deltaY, min, max);
        this.zoom(this.currentMedia, newZoomValue, false);
      }
    }

    /**
     * When user uses thumbnails arrow (just scroll thumbnails)
     * @param {event} event
     * @param {node} arrow
     */
  }, {
    key: "onThumbnailsArrowClick",
    value: function onThumbnailsArrowClick(event, arrow) {
      if (this.thumbnailsItems.length > 1) {
        var top, left;
        if (arrow.dataset.controls === 'prev') {
          top = this.thumbnails.scrollTop - this.thumbnailsItems[1].offsetTop;
          left = this.thumbnails.scrollLeft - this.thumbnailsItems[1].offsetLeft;
        }
        if (arrow.dataset.controls === 'next') {
          top = this.thumbnails.scrollTop + this.thumbnailsItems[1].offsetTop;
          left = this.thumbnails.scrollLeft + this.thumbnailsItems[1].offsetLeft;
        }
        this.thumbnails.scrollTo({
          top: top,
          left: left,
          behavior: 'smooth'
        });
      }
    }

    /**
     * When user uses medias arrow
     * @param {event} event
     * @param {node} arrow
     */
  }, {
    key: "onMediasArrowClick",
    value: function onMediasArrowClick(event, arrow) {
      this.enableArrows(false);
      if (arrow.dataset.controls === 'prev') this.goTo(this.currentIndex - 1, 'smooth');
      if (arrow.dataset.controls === 'next') this.goTo(this.currentIndex + 1, 'smooth');
    }

    /**
     * Enable or disable arrows buttons
     * @param {boolean} state
     */
  }, {
    key: "enableArrows",
    value: function enableArrows() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      [].concat(_toConsumableArray(this.thumbnailsArrowButtons), _toConsumableArray(this.mediasArrowButtons)).forEach(function (button) {
        return button.disabled = !state;
      });
    }

    /**
     * Go to a specific index
     * (synchronize thumbnails and medias)
     * @param {number} index
     * @param {string} behavior scroll behavior (smooth, instant or null)
     */
  }, {
    key: "goTo",
    value: function goTo() {
      var _this7 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      index = utils.getMinMax(+index, 0, this.thumbnailsItems.length);
      if (index === this.currentIndex) behavior = 'instant';
      if (this.thumbnailsItems[index] && this.mediasItems[index]) {
        this.isMoving = true;
        this.currentIndex = index;
        this.currentThumbnail = this.thumbnailsItems[index];
        this.currentMedia = this.mediasItems[index];

        // Highlight thumbnail
        this.thumbnailsItems.forEach(function (item) {
          return item.classList.toggle('active', +item.dataset.index === _this7.currentIndex);
        });

        // Synchronize thumbnails and medias
        setTimeout(function () {
          _this7.medias.scrollTo({
            top: 0,
            left: Math.round(_this7.medias.clientWidth * index),
            behavior: behavior
          });
          _this7.thumbnails.scrollTo({
            top: Math.round(_this7.currentThumbnail.offsetTop - _this7.thumbnailsArrowButtons[0].clientHeight),
            left: Math.round(_this7.currentThumbnail.offsetLeft),
            behavior: behavior
          });
        }, 0);

        // Hide Zoom buttons if media is not a photo
        this.mediasZoomButtons.forEach(function (button) {
          button.classList.toggle('hidden', !_this7.currentMedia.classList.toString().includes('photo'));
        });

        // Reset All medias after transition
        var duration = behavior === 'smooth' ? 750 : 0;
        clearTimeout(this.resetTimeout);
        this.resetTimeout = setTimeout(function () {
          _this7.pauseAllVideos();
          _this7.resetZoom();
          _this7.resetDrag();
          _this7.toggleThumbnailsArrowButtons();
          _this7.toggleMediasArrowButtons();
          _this7.enableArrows(true);
          _this7.isMoving = false;
        }, duration);
      }
    }

    /**
     * add a gradient over thumbnails if edge are not reached
     * Display thumbnails arrows on thumbnails if necessary
     */
  }, {
    key: "toggleThumbnailsArrowButtons",
    value: function toggleThumbnailsArrowButtons() {
      var thumbnailScrollTop = this.thumbnails.scrollTop;
      var thumbnailsHeight = this.thumbnails.scrollHeight - this.thumbnails.clientHeight;
      var _this$thumbnailsArrow = _slicedToArray(this.thumbnailsArrowButtons, 2),
        arrowPrev = _this$thumbnailsArrow[0],
        arrowNext = _this$thumbnailsArrow[1];
      arrowPrev.classList.toggle('hidden', this.thumbnails.scrollHeight < this.mediaZoom.clientHeight);
      arrowPrev.classList.toggle('active', thumbnailScrollTop > 0);
      arrowNext.classList.toggle('hidden', this.thumbnails.scrollHeight < this.mediaZoom.clientHeight);
      arrowNext.classList.toggle('active', thumbnailScrollTop < thumbnailsHeight);
    }

    /**
     * Display medias arrows on thumbnails if necessary
     */
  }, {
    key: "toggleMediasArrowButtons",
    value: function toggleMediasArrowButtons() {
      var mediasScrollLeft = this.medias.scrollLeft;
      var mediasWidth = (this.mediasItems.length - 1) * this.medias.clientWidth;
      var offset = Math.floor(this.medias.clientWidth / 10);
      var _this$mediasArrowButt = _slicedToArray(this.mediasArrowButtons, 2),
        arrowPrev = _this$mediasArrowButt[0],
        arrowNext = _this$mediasArrowButt[1];
      arrowPrev.classList.toggle('ka-nav-button--hidden', mediasScrollLeft <= offset);
      arrowNext.classList.toggle('ka-nav-button--hidden', mediasScrollLeft >= mediasWidth - offset);
    }

    /**
     * Rewind and pause all videos
     */
  }, {
    key: "pauseAllVideos",
    value: function pauseAllVideos() {
      this.mediaZoom.querySelectorAll('video').forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
    }

    /**
     * onZoomButtonsClick on current media
     * @param {string} direction (in or out)
     */
  }, {
    key: "onZoomButtonsClick",
    value: function onZoomButtonsClick(direction) {
      var _settings$zoom5 = settings.zoom,
        min = _settings$zoom5.min,
        max = _settings$zoom5.max,
        step = _settings$zoom5.step;
      var newZoomValue = utils.getMinMax(this.currentZoom + {
        "in": 1,
        out: -1
      }[direction] * step, min, max);
      this.zoom(this.currentMedia, newZoomValue, true);
      this.currentZoom = newZoomValue;
    }

    /**
     * Disable zoom button if zoom reach edges
     * @param {number} value
     */
  }, {
    key: "toggleZoomButtons",
    value: function toggleZoomButtons(value) {
      var _settings$zoom6 = settings.zoom,
        min = _settings$zoom6.min,
        max = _settings$zoom6.max;
      var _this$mediasZoomButto = _slicedToArray(this.mediasZoomButtons, 2),
        minusButton = _this$mediasZoomButto[0],
        plusButton = _this$mediasZoomButto[1];
      minusButton.classList.toggle('disabled', value <= min);
      plusButton.classList.toggle('disabled', value >= max);
    }

    /**
     * Apply a zoom value on a specific item
     * @param {node} media item to zoom
     * @param {number} value percentage of zoom
     * @param {boolean} animation CSS transition, default true
     */
  }, {
    key: "zoom",
    value: function zoom(media, value) {
      var animation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var min = settings.zoom.min;
      var image = media.querySelector('img');
      this.isZoomed = value > min;
      if (image) {
        image.classList.toggle('transition', animation);
        this.toggleZoomButtons(value);
        this.currentZoom = value;
        if (value > min) {
          media.classList.add('zoomed');
          image.style.transform = "scale(".concat(value / 100, ")");
          image.dataset.zoom = value;
        } else {
          media.classList.remove('zoomed');
          image.removeAttribute('data-zoom');
          image.style.transform = null;
          this.resetDrag();
        }
        image.addEventListener('transitionend', function () {
          image.classList.remove('transition');
        }, {
          once: true
        });
      }
    }

    /**
     * Reset zoom value on every medias image
     */
  }, {
    key: "resetZoom",
    value: function resetZoom() {
      var _this8 = this;
      this.mediasItems.forEach(function (item) {
        return _this8.zoom(item, settings.zoom.min, false);
      });
      this.currentZoom = settings.zoom.min;
      this.currentPinch = 1;
    }

    /**
     * Apply a zoom value on a specific item
     * @param {node} media item to zoom
     * @param {number} value percentage of zoom
     */
  }, {
    key: "drag",
    value: function drag(media, x, y) {
      var image = media.querySelector('img');
      if (image) {
        image.style.left = x ? "".concat(x, "px") : null;
        image.style.top = x ? "".concat(y, "px") : null;
        x ? image.dataset.x = x : image.removeAttribute('data-x');
        y ? image.dataset.y = y : image.removeAttribute('data-y');
        media.classList.toggle('dragged', x || y);
      }
    }

    /**
     * Reset drag position on every medias image
     */
  }, {
    key: "resetDrag",
    value: function resetDrag() {
      var _this9 = this;
      this.mediasItems.forEach(function (item) {
        return _this9.drag(item, 0, 0);
      });
      this.currentPosX = 0;
      this.currentPosY = 0;
    }
  }]);
}();
export { MediaZoom as default };